(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function show(el) {
    if (el) el.classList.remove('is-hidden');
  }

  function hide(el) {
    if (el) el.classList.add('is-hidden');
  }

  function clearChildren(el) {
    if (!el) return;
    while (el.firstChild) el.removeChild(el.firstChild);
  }

  function formatDate(value) {
    if (!value) return '';
    var date = new Date(value);
    if (isNaN(date.getTime())) return value;
    return date.toLocaleString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  function load17TrackScript() {
    if (window.YQV5) return Promise.resolve();
    if (window.__nxedc17TrackLoading) return window.__nxedc17TrackLoading;

    window.__nxedc17TrackLoading = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = 'https://www.17track.net/externalcall.js';
      script.async = true;
      script.onload = function () { resolve(); };
      script.onerror = function () { reject(new Error('Tracking widget failed to load.')); };
      document.head.appendChild(script);
    });

    return window.__nxedc17TrackLoading;
  }

  function renderTimeline(container, events) {
    clearChildren(container);
    if (!events || !events.length) {
      hide(container);
      return;
    }

    events.forEach(function (event) {
      var item = document.createElement('div');
      item.className = 'nxedc-track-order__event';

      var marker = document.createElement('div');
      marker.className = 'nxedc-track-order__event-marker';

      var body = document.createElement('div');
      var title = document.createElement('div');
      title.className = 'nxedc-track-order__event-title';
      title.textContent = event.title || 'Update';

      body.appendChild(title);

      if (event.detail) {
        var detail = document.createElement('div');
        detail.className = 'nxedc-track-order__event-detail';
        detail.textContent = event.detail;
        body.appendChild(detail);
      }

      if (event.at) {
        var time = document.createElement('div');
        time.className = 'nxedc-track-order__event-time';
        time.textContent = formatDate(event.at);
        body.appendChild(time);
      }

      item.appendChild(marker);
      item.appendChild(body);
      container.appendChild(item);
    });

    show(container);
  }

  function renderSummary(container, order) {
    clearChildren(container);
    if (!order) {
      hide(container);
      return;
    }

    var rows = [
      ['Order', order.name],
      ['Status', order.fulfillmentStatus || order.financialStatus],
      ['Placed', formatDate(order.createdAt)]
    ];

    rows.forEach(function (row) {
      if (!row[1]) return;
      var line = document.createElement('p');
      line.innerHTML = '<strong>' + row[0] + ':</strong> ' + row[1];
      container.appendChild(line);
    });

    if (order.items && order.items.length) {
      var items = document.createElement('p');
      items.innerHTML = '<strong>Items:</strong> ' + order.items.map(function (item) {
        return item.title + ' × ' + item.quantity;
      }).join(', ');
      container.appendChild(items);
    }

    show(container);
  }

  function render17TrackEmbed(container, trackingNumber, provider) {
    clearChildren(container);
    if (!trackingNumber) return;

    if (provider === 'iframe') {
      var iframe = document.createElement('iframe');
      iframe.src = 'https://t.17track.net/en#nums=' + encodeURIComponent(trackingNumber);
      iframe.title = 'Tracking details';
      iframe.loading = 'lazy';
      container.appendChild(iframe);
      return;
    }

    var host = document.createElement('div');
    host.id = 'nxedc-track-embed-' + Date.now();
    container.appendChild(host);

    load17TrackScript()
      .then(function () {
        if (!window.YQV5 || typeof window.YQV5.trackSingle !== 'function') {
          throw new Error('Tracking widget unavailable.');
        }
        window.YQV5.trackSingle({
          YQ_ContainerId: host.id,
          YQ_Height: 560,
          YQ_Fc: '0',
          YQ_Lang: 'en',
          YQ_Num: trackingNumber
        });
      })
      .catch(function () {
        var iframe = document.createElement('iframe');
        iframe.src = 'https://t.17track.net/en#nums=' + encodeURIComponent(trackingNumber);
        iframe.title = 'Tracking details';
        iframe.loading = 'lazy';
        container.appendChild(iframe);
      });
  }

  function lookupOrder(root, orderNumber, contact) {
    var endpoint = root.getAttribute('data-order-lookup-url') || '/apps/sparkedc-track/order';
    var url = endpoint + (endpoint.indexOf('?') === -1 ? '?' : '&') +
      'order_number=' + encodeURIComponent(orderNumber) +
      '&contact=' + encodeURIComponent(contact);

    return fetch(url, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || !data.ok) {
          throw new Error((data && data.error) || 'Order lookup failed.');
        }
        return data;
      });
    });
  }

  function initTrackOrder(root) {
    var results = qs(root, '[data-nxedc-track-order-results]');
    var summary = qs(root, '[data-nxedc-track-order-summary]');
    var timeline = qs(root, '[data-nxedc-track-order-timeline]');
    var embed = qs(root, '[data-nxedc-track-order-embed]');
    var error = qs(root, '[data-nxedc-track-order-error]');
    var provider = root.getAttribute('data-tracking-provider') || '17track';

    function resetResults() {
      hide(results);
      hide(error);
      hide(summary);
      hide(timeline);
      clearChildren(summary);
      clearChildren(timeline);
      clearChildren(embed);
    }

    function showResults(title) {
      var titleEl = qs(results, '[data-nxedc-track-order-results-title]');
      if (titleEl && title) titleEl.textContent = title;
      hide(error);
      show(results);
      results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function showError(message) {
      clearChildren(embed);
      hide(summary);
      hide(timeline);
      if (error) error.textContent = message;
      show(error);
      show(results);
      results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    root.querySelectorAll('[data-nxedc-track-order-form]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;

        var mode = form.getAttribute('data-nxedc-track-order-form');
        clearChildren(embed);
        hide(error);
        hide(summary);
        hide(timeline);

        if (mode === 'tracking') {
          var trackingInput = form.querySelector('[name="tracking_number"]');
          var trackingNumber = trackingInput ? trackingInput.value.trim() : '';
          if (!trackingNumber) {
            if (submitBtn) submitBtn.disabled = false;
            showError('Please enter a tracking number.');
            return;
          }

          showResults('Tracking Results');
          render17TrackEmbed(embed, trackingNumber, provider);
          if (submitBtn) submitBtn.disabled = false;
          return;
        }

        var orderInput = form.querySelector('[name="order_number"]');
        var contactInput = form.querySelector('[name="contact"]');
        var orderNumber = orderInput ? orderInput.value.trim() : '';
        var contact = contactInput ? contactInput.value.trim() : '';

        if (!orderNumber || !contact) {
          if (submitBtn) submitBtn.disabled = false;
          showError('Please enter your order number and email or phone number.');
          return;
        }

        lookupOrder(root, orderNumber, contact)
          .then(function (data) {
            showResults('Order Tracking');
            renderSummary(summary, data.order);
            renderTimeline(timeline, data.events || []);

            var trackingNumber = (data.trackingNumbers && data.trackingNumbers[0]) || '';
            if (trackingNumber) {
              render17TrackEmbed(embed, trackingNumber, provider);
            } else {
              clearChildren(embed);
            }
          })
          .catch(function () {
            var shopId = root.getAttribute('data-shop-id');
            if (shopId) {
              var statusUrl = 'https://shopify.com/' + shopId + '/account/login?return_url=' +
                encodeURIComponent('/account/orders');
              showError('We could not verify this order here. Please sign in to view your order status, or track with your shipping number on the right.');
              var link = document.createElement('a');
              link.className = 'nxedc-track-order__link';
              link.href = statusUrl;
              link.target = '_blank';
              link.rel = 'noopener';
              link.textContent = 'Open order status';
              link.style.marginTop = '12px';
              link.style.display = 'inline-block';
              if (error) error.appendChild(document.createElement('br'));
              if (error) error.appendChild(link);
              return;
            }
            showError('Unable to find this order. Please check your details and try again.');
          })
          .finally(function () {
            if (submitBtn) submitBtn.disabled = false;
          });
      });
    });

    var resetBtn = qs(root, '[data-nxedc-track-order-reset]');
    if (resetBtn) {
      resetBtn.addEventListener('click', resetResults);
    }

    root.querySelectorAll('[data-nxedc-track-prefill]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var trackingNumber = btn.getAttribute('data-nxedc-track-prefill');
        var trackingInput = root.querySelector('[name="tracking_number"]');
        if (trackingInput) trackingInput.value = trackingNumber;
        showResults('Tracking Results');
        render17TrackEmbed(embed, trackingNumber, provider);
      });
    });
  }

  ready(function () {
    document.querySelectorAll('[data-nxedc-track-order]').forEach(initTrackOrder);
  });
})();
